import { Camelized } from 'humps';

export enum FilterType {
  MULTI_SELECTOR = 'MULTI_SELECTOR',
  DATE_RANGE = 'DATE_RANGE',
}

export interface MultiSelectorValueRaw {
  id: string;
  display_name: string;
}

export interface MultiSelectorRaw {
  limit: number;
  values: MultiSelectorValueRaw[];
}

export interface DateRangeRaw {
  start_date: string;
  end_date: string;
  latest_date_time_allowed: string;
}

export interface MultiSelectorFilterDetailRaw {
  type: FilterType.MULTI_SELECTOR;
  parameter_name: string;
  multi_selector: MultiSelectorRaw;
}

export interface DateRangeFilterDetailRaw {
  type: FilterType.DATE_RANGE;
  parameter_name: string;
  date_range: DateRangeRaw;
}

export type FilterDetailRaw =
  | MultiSelectorFilterDetailRaw
  | DateRangeFilterDetailRaw;

export interface InsightsDashboardReportRaw {
  authorization_key: string;
  authorization_token: string;
  dashboard_id: string;
  unique_name: string;
  display_name: string;
  enabled: boolean;
  data_last_updated: string;
  filter_details: FilterDetailRaw[];
}

export interface InsightReportsResponseRaw {
  reports: InsightsDashboardReportRaw[];
}

export type MultiSelectorValue = Camelized<MultiSelectorValueRaw>;
export type MultiSelector = Camelized<MultiSelectorRaw>;
export type DateRange = Camelized<DateRangeRaw>;
export type MultiSelectorFilterDetail = Camelized<MultiSelectorFilterDetailRaw>;
export type DateRangeFilterDetail = Camelized<DateRangeFilterDetailRaw>;
export type FilterDetail = MultiSelectorFilterDetail | DateRangeFilterDetail;
export type InsightsDashboardReport = Camelized<InsightsDashboardReportRaw>;
export type InsightReportsResponse = Camelized<InsightReportsResponseRaw>;
